export default {
  en: {
    backtext: 'Back',
  },
  es: {
    backtext: 'Regresar',
  }
};
